export default class GeneralUtilService {
  static generateRandomString(length = 10, includeDateTime = false) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';

    for (let counter = 0; counter < length; counter += 1) {
      randomString += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    if (includeDateTime) {
      const now = new Date().toISOString().slice(0, 19).replace('T', ' ');
      randomString = `${randomString}_${now.replace(' ', '_')}`;
    }

    return randomString;
  }
}
